import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=0e7a1554&scoped=true&"
import script from "./OrderProduct.vue?vue&type=script&lang=ts&"
export * from "./OrderProduct.vue?vue&type=script&lang=ts&"
import style0 from "./OrderProduct.vue?vue&type=style&index=0&id=0e7a1554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a1554",
  null
  
)

export default component.exports